/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalTwoDrawerRefrigeratorW24Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalTwoDrawerRefrigeratorW24').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'REFRIGERATOR_LN24DWR',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-two-drawer-refrigerator-w-24.js.map